import PropTypes from 'prop-types'
import { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'next-i18next'

// Context
import { FilterContext } from '../../context/FilterContext'

// Internal components
import DetailCard from '../DetailCard/DetailCard'
import Button from '../Button/Button'
import Loader from '../Loader/Loader'
import { UserContext } from '../../context/UserContext'

const OverviewGrid = (props) => {
  const { data, loading, type } = props

  // Context
  const filterContext = useContext(FilterContext)
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  // States
  const [cards, setCards] = useState([])
  const [mounted, setMounted] = useState(0)
  const [filterType, setFilterType] = useState(false)
  const [filterSelected, setFilterSelected] = useState(false)

  useEffect(() => {
    setFilterSelected(filterContext.selectedFilters)
  }, [])

  useEffect(() => {
    setMounted(mounted + 1)
  }, [filterContext.selectedFilters])

  useEffect(() => {
    const cardsArr = []
    const dataArr = []
    const newData = Array.from(data)
    cards.forEach((card) => cardsArr.push(card.id))
    newData.forEach((card) => dataArr.push(card.id))
    if (dataArr.toString() === cardsArr.toString()) return false
    if (type === filterType && filterContext.selectedFilters === filterSelected) {
      setCards((prevData) => [...prevData, ...newData])
    } else {
      if (filterSelected !== filterContext.selectedFilters) setMounted(mounted + 1)
      setCards(data)
    }
    setFilterSelected(filterContext.selectedFilters)
    setFilterType(type)
  }, [data])

  const resetForm = (e) => {
    filterContext.setResetFilters(true)
    e.preventDefault()
  }

  const incrementLimit = () => {
    filterContext.setFrom(filterContext.from + 8)
  }

  // swtich-case in order to see which translation to provide
  const renderSwitch = (param) => {
    switch (param) {
      case 'exercises':
        return <span className="OverviewGrid-fallbackDescription">{t('OVERVIEWGRID__FALLBACK_EXERCISE_TEXT')}</span>
      case 'trainings':
        return <span className="OverviewGrid-fallbackDescription">{t('OVERVIEWGRID__FALLBACK_TRAINING_TEXT')}</span>
      default:
        return <span className="OverviewGrid-fallbackDescription">{t('OVERVIEWGRID__FALLBACK_PROGRAMS_TEXT')}</span>
    }
  }

  return (
    <div className={`OverviewGrid OverviewGrid--${type} ${loading ? 'is-loading' : ''}`}>
      <div className="OverviewGrid-inner">
        <div className="OverviewGrid-container">
          {loading && (
            <div className="OverviewGrid-transition">
              <div className="OverviewGrid-transitionOverlay">
                <Loader />
              </div>
            </div>
          )}
          {cards.length > 0
            ? cards.map((card, index) => {
                return (
                  <DetailCard
                    cardData={card}
                    cardIndex={index}
                    cardType={'overview'}
                    direction={'vertical'}
                    modifiers={'DetailCard--overviewGrid'}
                    key={`DetailCard--${type}_${card.id}_${index}_${mounted}`}
                  />
                )
              })
            : filterSelected &&
              !loading && (
                <div className="OverviewGrid-fallback">
                  <div className="OverviewGrid-fallbackContent">
                    <span className="OverviewGrid-fallbackTitle">{t('OVERVIEWGRID__FALLBACK_TITLE')}</span>
                    {renderSwitch(type)}
                    <Button
                      label={t('OVERVIEWGRID__BTN_RESET')}
                      icon={{ id: 'icon-reset', before: true }}
                      modifiers={['Button--addDetailPage']}
                      onClick={(e) => resetForm(e)}
                    />
                  </div>
                </div>
              )}
        </div>
        <div className="OverviewGrid-footer">
          {filterContext.total > filterContext.from && data && (
            <Button
              onClick={(e) => incrementLimit(e)}
              label={t('OVERVIEWGRID__BTN_LOADMORE')}
              icon={{ id: 'icon-chevron-right' }}
              modifiers={['Button--loadMore']}
            />
          )}
        </div>
      </div>
    </div>
  )
}

OverviewGrid.propTypes = {
  type: PropTypes.string,
  data: PropTypes.any,
  loading: PropTypes.bool
}

export default OverviewGrid
